import { api } from "./client";

export type FlavorStat = {
  flavor: string;
  model: string;
  count: number;
};

export type RepeatBuyer = {
  phone: string;
  purchases: number;
  totalSpent: number;
};

export type MonthlyRevenue = {
  month: string;
  revenue: number;
};

export type BatchStats = {
  totalStock: number;
  totalSold: number;
  dailyRate: number;
  daysToSellOut: number;
};

export type Analytics = {
  totalRevenue: number;
  totalSales: number;
  flavorVelocity: FlavorStat[];
  repeatBuyers: RepeatBuyer[];
  monthlyRevenue: MonthlyRevenue[];
  shippingDelta: number;
  batchStats: BatchStats;
};

export type ForecastRecommendation = {
  flavor: string;
  model: string;
  demand: number;
  proportion: number;
  recommendedQty: number;
  estimatedCost: number;
};

export type Forecast = {
  availableBudget: number;
  dailyRate: number;
  daysToSellOut: number | null;
  recommendations: ForecastRecommendation[];
};

export const analyticsApi = {
  get: () => api.get<Analytics>("/api/analytics"),
  forecast: () => api.get<Forecast>("/api/forecast"),
};
